var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTalentgoals02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2117 57.57H66.7883C67.575 57.57 68.165 56.98 68.165 56.1934V23.7434C68.165 22.9567 67.575 22.3667 66.7883 22.3667H18.2117C17.5233 22.3667 16.9333 22.9567 16.9333 23.7434V56.1934C16.9333 56.98 17.5233 57.57 18.2117 57.57ZM13 62.3884C13 63.9617 14.2783 65.6334 15.95 65.6334H69.05C70.6233 65.6334 72 63.9617 72 62.3884H13Z",
    fill: "#450ADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0833 57.5698H17.9167L13 62.3882H72L67.0833 57.5698Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4117 57.9634H19.5884L17.9167 59.93H67.0834L65.4117 57.9634Z",
    fill: "#450ADF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5149 60.8149H37.4849L36.6982 61.8966H48.3016L47.5149 60.8149Z",
    fill: "#450ADF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8833 25.3169H65.1166V54.6202H19.8833V25.3169Z",
    fill: "#FBC02D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5003 24.7267C42.9348 24.7267 43.287 24.3745 43.287 23.94C43.287 23.5055 42.9348 23.1533 42.5003 23.1533C42.0658 23.1533 41.7136 23.5055 41.7136 23.94C41.7136 24.3745 42.0658 24.7267 42.5003 24.7267Z",
    fill: "#FBC02D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7288 64.4535H38.2721C37.9771 64.4535 37.1904 64.4535 37.1904 63.4702H47.8104C47.8104 64.4535 47.0238 64.4535 46.7288 64.4535Z",
    fill: "#FBC02D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTalentgoals02);
export default __webpack_public_path__ + "static/media/ico_talentgoals_02.ff335ec2baeefca90ba7ccd8b93248c4.svg";
export { ForwardRef as ReactComponent };